import Actions from 'actions';

const initialState = Object.freeze({});

function languages(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_LANGUAGES_REQUEST:
      return initialState;
    case Actions.FETCH_LANGUAGES_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_LANGUAGES_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default languages;
